import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _isEmpty from 'lodash/isEmpty';
import Preloader from '@omilia/preloader';

import Modal, { ModalHeader, ModalBody, ModalFooter } from 'components/Modal';
import { purgeItemType } from 'types';
import Button from 'components/Button';
import PurgeList from './components/PurgeList';
import './style.scss';

export default class ProjectPurgeModal extends Component {
  static propTypes = {
    isOpen: PropTypes.bool,
    onCloseModal: PropTypes.func,
    purgeProject: PropTypes.func,
    purgeList: PropTypes.shape(purgeItemType),
    isLoading: PropTypes.bool,
    isPurging: PropTypes.bool,
    purgableDataAreEmpty: PropTypes.bool,
    availablePurgableItemExists: PropTypes.bool,
  };

  renderPurgeList() {
    const { purgeList, purgableDataAreEmpty } = this.props;
    if (_isEmpty(purgeList) && purgableDataAreEmpty) return null;
    return <PurgeList purgeList={purgeList} />;
  }

  renderPreLoader() {
    const { isLoading } = this.props;

    if (isLoading) {
      return <Preloader />;
    }

    return null;
  }

  renderNoItems() {
    const { isLoading, purgableDataAreEmpty } = this.props;
    if (purgableDataAreEmpty && !isLoading) {
      return (
        <div styleName="no-items">
          <p>Your recycle bin is empty</p>
        </div>
      );
    }

    return null;
  }

  render() {
    const {
      isOpen,
      onCloseModal,
      isPurging,
      purgeProject,
      availablePurgableItemExists,
    } = this.props;

    return (
      <Modal
        isOpen={isOpen}
        closeOnEsc
        onCloseRequest={onCloseModal}
        styleName="modal-container"
      >
        <ModalHeader
          title="PURGE ITEMS"
          subtitle="Clear the following items from list:"
          styleName="header"
          icon={<span className="icon-recycle-bin" />}
        />

        <ModalBody styleName="purge-container">
          {this.renderPurgeList()}
          {this.renderPreLoader()}
          {this.renderNoItems()}
        </ModalBody>

        <ModalFooter justifyContent="flex-end">
          <Button
            isLarge
            type="button"
            isTransparent
            onClick={onCloseModal}
            data-test="cancel-button"
          >
            Cancel
          </Button>

          <Button
            isLarge
            type="button"
            isLoading={isPurging}
            onClick={purgeProject}
            disabled={isPurging || !availablePurgableItemExists}
            data-test="purge"
          >
            CLEAR ITEMS
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}
